// extracted by mini-css-extract-plugin
export default {"container":"WF9eP","innerContainer":"Ow79c","title":"FyFDT","body":"_8moJr","list":"bFP9j","button":"PbIh5","isMuted":"rUzGC"};